import React from 'react';

import { spacing } from '@rbilabs/universal-components/themes';
import { useRouter } from 'expo-router';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { CardModalHeader } from 'components/card-modal-header';
import { DeliveryFeesStripe } from 'components/delivery-fees-stripe';
import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { routes } from 'utils/routing';

interface IMenuHeaderNavigation {
  title?: string;
  headerBackgroundColorOverride?: string | null;
}

export const MenuHeaderNavigation = ({
  title = '',
  headerBackgroundColorOverride,
}: IMenuHeaderNavigation) => {
  const isDesktop = useIsDesktopBreakpoint();
  const { top } = useSafeAreaInsets();
  const router = useRouter();

  return (
    <View
      style={{
        paddingTop: isDesktop ? 0 : top || spacing.$4,
        backgroundColor: headerBackgroundColorOverride,
      }}
    >
      {isDesktop && <StandardMobileHeader />}
      <CenteredRowContainer>
        <CardModalHeader
          headerText={title}
          dismissType="back"
          // always go back to menu even on deep link from another area
          onDismiss={() => (router.canGoBack() ? router.back() : router.replace(routes.menu))}
          isLoading={!title}
          backgroundColorOverride={headerBackgroundColorOverride}
          containerStyle={{
            paddingBottom: 0,
            paddingTop: isDesktop ? undefined : 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        />
        <DeliveryFeesStripe />
      </CenteredRowContainer>
    </View>
  );
};
